export default (el, {}, { cleanup }) => {
    let separatorKeyHandled = false;

    const onKeydown = (e) => {
        if (e.key !== 'Backspace' && e.key !== 'Delete') return;
        if (el.selectionStart !== el.selectionEnd) return;

        const pos = el.selectionStart;
        const tp = e.key === 'Backspace' ? pos - 1 : pos;
        if (tp < 0 || tp >= el.value.length) return;
        if (el.value[tp] !== '.' && el.value[tp] !== ',') return;

        e.preventDefault();
        const np = e.key === 'Backspace' ? pos - 1 : pos + 1;
        el.setSelectionRange(np, np);
        separatorKeyHandled = true;
    };

    const onKeyup = (e) => {
        if (separatorKeyHandled) {
            separatorKeyHandled = false;
            return;
        }

        if (e.key.length === 1 || e.key === 'Backspace' || e.key === 'Delete') {
            el.dispatchEvent(new Event('input'));
        }
    };

    el.addEventListener('keydown', onKeydown);
    el.addEventListener('keyup', onKeyup);
    cleanup(() => {
        el.removeEventListener('keydown', onKeydown);
        el.removeEventListener('keyup', onKeyup);
    });
};
